import React from "react";


import { AppBar, Toolbar, Typography, Button, Container, } from '@mui/material';
import { grey } from '@mui/material/colors';
import { Copyright } from "@mui/icons-material";

interface MyComponentProps {
    children: any // Ensure you define children prop type
}


const Footer: React.FC<MyComponentProps> = ({ children }) => {
    return (
        <>
            {children}
            {/* <AppBar position="static" sx={{ backgroundColor: '#1976d2' }}> */}
            <Container>
                {/* <Toolbar> */}
                    {/* <Typography> footer</Typography> */}
                {/* </Toolbar> */}
            </Container>
        {/* </AppBar> */}
        </>
    );
};
export default Footer